export default "__VITE_ASSET__5bc9808d__"